import MuiButton from "./MuiButton";
import MuiCardActions from "./MuiCardActions";
import MuiCardContent from "./MuiCardContent";
import MuiCardHeader from "./MuiCardHeader";
import MuiChip from "./MuiChip";
import MuiIconButton from "./MuiIconButton";
import MuiInputBase from "./MuiInputBase";
import MuiLinearProgress from "./MuiLinearProgress";
import MuiListItem from "./MuiListItem";
import MuiListItemIcon from "./MuiListItemIcon";
import MuiOutlinedInput from "./MuiOutlinedInput";
import MuiPaper from "./MuiPaper";
import MuiTableCell from "./MuiTableCell";
import MuiTableHead from "./MuiTableHead";
import MuiTableRow from "./MuiTableRow";
import MuiToggleButton from "./MuiToggleButton";
import MuiTypography from "./MuiTypography";

const components = {
	MuiButton,
	MuiCardActions,
	MuiCardContent,
	MuiCardHeader,
	MuiChip,
	MuiIconButton,
	MuiInputBase,
	MuiLinearProgress,
	MuiListItem,
	MuiListItemIcon,
	MuiOutlinedInput,
	MuiPaper,
	MuiTableCell,
	MuiTableHead,
	MuiTableRow,
	MuiToggleButton,
	MuiTypography,
};
export default components;
